import { render } from "./Productos.vue?vue&type=template&id=42d231e5"
import script from "./Productos.vue?vue&type=script&lang=js"
export * from "./Productos.vue?vue&type=script&lang=js"
script.render = render

export default script